import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";

@Component({
  selector: "confirmation-dialog",
  templateUrl: "./confirmation-dialog.component.html",
  styleUrls:["./confirmation-dialog.scss"]
})
export class ConfirmationDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ConfirmationDialogComponent>
  ) {}

  confirm(): void {
    this.dialogRef.close(true);
  }
}
